@if (potentialMismatchedFingerprintAssociation) {
  <ng-template #popoverBody>
    <p>
      There is a potential mismatch with the fingerprint card information received and what is currently on file. Please
      review the fingerprint card information received to determine if action needs to be taken. The following
      mismatches have been identified:
    </p>
    @if (potentialMismatchedFingerprintAssociation.ssnMismatch) {
      <span class="badge badge-info me-2">SSN Mismatch</span>
    }
    @if (potentialMismatchedFingerprintAssociation.dobMismatch) {
      <span class="badge badge-warning me-2">DOB Mismatch</span>
    }
    @if (potentialMismatchedFingerprintAssociation.firstNameMismatch) {
      <span class="badge badge-danger me-2">First Name Mismatch</span>
    }
    @if (potentialMismatchedFingerprintAssociation.lastNameMismatch) {
      <span class="badge badge-danger me-2">Last Name Mismatch</span>
    }
    @if (potentialMismatchedFingerprintAssociation.middleInitialMismatch) {
      <span class="badge badge-danger">Middle Initial Mismatch</span>
    }
  </ng-template>
  <span
    [ngbPopover]="popoverBody"
    [popoverClass]="'mismatched-fp-popover'"
    triggers="mouseenter:mouseleave"
    container="body"
    class="badge badge-danger ms-2 my-auto modal-sm"
    [ngClass]="makeLarge ? 'badge-lg' : ''"
    (click)="$event.stopPropagation()"
  >
    Potential Mismatch<i class="bi bi-question-circle ps-1"></i>
  </span>
}
